module.exports = __webpack_public_path__ + "img/newsTitle.b1a94dbc.png";